module.exports = __webpack_public_path__ + "static/bg_interview_section-e2f69d94608face1a19881cc1ef88078.png";